import { render, staticRenderFns } from "./Commande.vue?vue&type=template&id=35d009e8&scoped=true"
import script from "./Commande.vue?vue&type=script&lang=js"
export * from "./Commande.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d009e8",
  null
  
)

export default component.exports